import * as React from "react";
import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <g
      id="Pink-Design-For-Dev"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Login-Copy-2"
        transform="translate(-140.000000, -607.000000)"
        fill="#F8F8F8"
        fillRule="nonzero"
      >
        <g id="Group-11" transform="translate(117.000000, 589.000000)">
          <g id="Group-6">
            <g id="facebook-logo" transform="translate(28.000000, 18.000000)">
              <path
                d="M11.5481152,0.00457746845 L8.66986088,0 C5.43624084,0 3.34653351,2.12508973 3.34653351,5.41422968 L3.34653351,7.91055211 L0.452577498,7.91055211 C0.20250534,7.91055211 0,8.11150297 0,8.35937289 L0,11.9762596 C0,12.2241295 0.202736247,12.4248515 0.452577498,12.4248515 L3.34653351,12.4248515 L3.34653351,21.5514081 C3.34653351,21.799278 3.54903885,22 3.79911101,22 L7.57490042,22 C7.82497258,22 8.02747792,21.7990491 8.02747792,21.5514081 L8.02747792,12.4248515 L11.4111874,12.4248515 C11.6612596,12.4248515 11.8637649,12.2241295 11.8637649,11.9762596 L11.8651504,8.35937289 C11.8651504,8.24035871 11.8173527,8.12637974 11.7326098,8.04215432 C11.647867,7.9579289 11.5324136,7.91055211 11.412342,7.91055211 L8.02747792,7.91055211 L8.02747792,5.79438844 C8.02747792,4.77727495 8.27200831,4.26093651 9.60872828,4.26093651 L11.5476534,4.26024989 C11.7974947,4.26024989 12,4.05929902 12,3.81165798 L12,0.453169377 C12,0.205757207 11.7977256,0.0050352153 11.5481152,0.00457746845 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </React.Fragment>,
  "IconFace"
);
